import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Checkbox } from 'antd';

class VariableBoolea extends Component {

    render() {
        const { estilsDiv, variable } = this.props;

        return (
            <div className={estilsDiv}>
                {variable.nom}
                <Checkbox
                    checked={variable.valor}
                    onChange={(event) => this.props.onChangeValorVariable(event.target.checked)}>
                </Checkbox>
            </div>
        );
    }
}

VariableBoolea.propTypes = {
    estilsDiv: PropTypes.string,
    variable: PropTypes.object,
    onChangeValorVariable: PropTypes.func
};

export default VariableBoolea;



// WEBPACK FOOTER //
// ./src/components/commons/variableBoolea.js